import { React, useEffect, useState } from "react";
import MarqueeManual from "../../../../hooks/marquee";
import { getMensajexArea } from "../../../../services/public/areas";
import { getAreapCook } from "../../../../utils/params";
import Toasts from "../../../toast";

function Bottom() {
  const [Mensajes, setMensajes] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [OpcMens, setOpcMens] = useState(true);

  const getMensajes = async () => 
    {
      const AreaId = getAreapCook();
      const response = await getMensajexArea(AreaId);
      if (response) 
        {
          if (response.status === 200) 
            {
              setMensajes(response.data.data);
            } 
          else 
          {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);        
         }
       } 
   };
  
  useEffect(() => {
  // Consulta al entrar a la pantalla
  getMensajes();

  // Luego vuelve a consultar cada 10 minutos
  const interval = setInterval(() => {
    getMensajes();
  }, 10 * 60 * 1000);

  return () => clearInterval(interval);
}, []);

  return (
    <>
    <div className="fixed bottom-0 w-full h-[4.5rem] shadow-[-2px_-27px_26px_-4px_rgba(0,_0,_0,_0.1)] border-t-stone-200 px-6">
      <span>
        {Mensajes.length>0 && (
          <MarqueeManual mensajes={Mensajes}></MarqueeManual>
                    ) 
        }
      </span>
    </div>
    {showToast ? (
    <Toasts
      type={opciones.type}
      message={opciones.message}
      active={opciones.active}
    ></Toasts>
  ) : (
    ""
  )}
    </>
  );
}

export default Bottom;
